// extracted by mini-css-extract-plugin
export default {"oss":"oss___ZWgzl","list_item":"list_item___zJfXT"};